// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"ProfileMenu_dropdown__3RskB","avatar":"ProfileMenu_avatar__3mNK-","menuIcon":"ProfileMenu_menuIcon__3I_u_"};